var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('nav-header'),_c('nav-menu'),_c('global-search'),_c('div',{staticClass:"content"},[_c('div',{staticClass:"banner"},[_vm._v("Guaranteed Authentic Cards or 100% Full Refund")]),_c('router-view')],1),_c('nav-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }